import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { goToAppStore } from "../lib/api";
import { FAQS } from "../data/faqData";

export const FAQ = () => {
  return (
    <section id="faq" className="py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="eyebrow">Good to know</span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl text-stylist-ink">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-stylist-ink2">
            Everything you need to know about how Senior Stylist works. Still curious? Ask our
            Admin using the chat in the corner.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-stylist-border"
              >
                <AccordionTrigger className="text-left font-serif text-lg md:text-xl text-stylist-ink hover:text-stylist-gold hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-[1.8] text-stylist-ink2 pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <div className="mt-12 text-center">
          <button
            onClick={goToAppStore}
            data-testid="faq-cta-subscribe"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-stylist-ink text-white px-8 py-4 text-sm hover:bg-stylist-gold transition-colors duration-300"
          >
            Subscribe today
          </button>
        </div>
      </div>
    </section>
  );
};
